import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FilterSelect from '../../components/FilterSelect';
import * as catalogueActions from '../../actions/catalogue';
import {
    catalogueStateKey,
    isCommonFilterDisabled,
    isCatalogueUpcoming
} from '../../helpers/catalogueUtils';

class VendorBuyerFilters extends PureComponent {
    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }
    render() {
        const {
            refinement: {
                sellerName,
                buyerDetail,
            },

            data: {
                sellerNameOptions,
                buyerDetailOptions,
            },

            // Seller
            loadSellerNameOptions,
            applyCatalogueSellerNameFilter,

            // Buyer
            loadBuyerDetailOptions,
            applyCatalogueBuyerDetailFilter,
        } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Vendor</span>
                    <FilterSelect
                        title="Vendor"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={sellerName}
                        options={sellerNameOptions}
                        onPopoverDidOpen={loadSellerNameOptions}
                        onChange={applyCatalogueSellerNameFilter}
                    />
                </div>
                {!isCatalogueUpcoming()
                    ? <div className="sales__catalogueRefineOptionGrp">
                        <span>Buyer</span>
                        <FilterSelect
                            title="Buyer"
                            alphabet
                            showSearch
                            disabled={this.isCommonFilterDisabled()}
                            value={buyerDetail}
                            options={buyerDetailOptions}
                            onPopoverDidOpen={loadBuyerDetailOptions}
                            onChange={applyCatalogueBuyerDetailFilter}
                        />
                    </div>
                    : null
                }
            </div>
        );
    }
}

VendorBuyerFilters.propTypes = {
    refinement: PropTypes.shape({
        sellerName: PropTypes.string,
        buyerDetiail: PropTypes.string,
    }).isRequired,

    data: PropTypes.shape({
        sellerNameOptions: PropTypes.array.isRequired,
        buyerDetailOptions: PropTypes.array.isRequired,
    }),

    // Seller
    loadSellerNameOptions: PropTypes.func.isRequired,
    applyCatalogueSellerNameFilter: PropTypes.func.isRequired,

    // Buyer
    loadBuyerDetailOptions: PropTypes.func.isRequired,
    applyCatalogueBuyerDetailFilter: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    const { refinement, data } = state[catalogueStateKey];
    return { refinement, data };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(catalogueActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorBuyerFilters);



// WEBPACK FOOTER //
// ./src/js/containers/Catalogue/VendorBuyerFilters.js